/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export { AddAsset };
class AddAsset {
    async do(spec, context) {
        if (spec.type !== "addasset") {
            throw new Error(`Editor API integrity error: expected type "addasset", received "${spec.type}" instead.`);
        }
        const { path, metadata, data } = spec;
        const { graph } = context;
        graph.assets ??= {};
        const asset = { data };
        graph.assets[path] = asset;
        if (metadata)
            asset.metadata = metadata;
        return {
            success: true,
            affectedGraphs: [],
            affectedModules: [],
            affectedNodes: [],
        };
    }
}
//# sourceMappingURL=add-asset.js.map